import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";

import TicketsByService from "../../components/organization/reports/TicketsPerService";
import { getReportDescription } from "../../store/helpers";
import {
  TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const TicketsByServicePage = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;

  const reportTitle = `${reportIndex}. Tickets Per Service`; 
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  //requires array of objects
  if (!_.isArray(data)) {
    data = [data];
  }

  return (
    <Box>
      <Box mb="20px">
        <h1>{reportTitle}</h1>
        <p className="reportDescription">
          {getReportDescription(reportRange).TicketsPerServiceBranches}
        </p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data) ? (
        data.map((a, index) => (
          <TicketsByService
            key={index}
            branchId={a.branchId}
            reportIndex={reportIndex}
            branchIndex={index + 1}
            data={a.serviceData}
            numServices={a.numServices}
            branchName={a.branchName}
          />
        ))
      ) : (
        <Box mt={10}>
          <p>No data available in this report</p>
        </Box>
      )}
    </Box>
  );
};

export default TicketsByServicePage;
